import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { MDBInput } from "mdb-react-ui-kit";
import apiService from "../../../Services/apiServices";
import { useToasts } from "react-toast-notifications";
import Search from "../../../PageComponents/Search/Search";
import globals from "../../../Services/globals";
import { confirmAlert } from "react-confirm-alert";
import helper from "../../../Services/helper";
import ExcelExport from "../../../PageComponents/Excel/ExcelExport";
import Print from "../../../PageComponents/Print/Print";
import Switch from "react-switch";
import MonthlyRptFormat from "../../exportFunctions/monthlyRptFormat";



function AccMonthlyReport(props) {

  const { addToast } = useToasts();
  const excelExportRef = useRef();
  const [mainData, setMainData] = useState([]);
  const [dataForPrint, setDataForPrint] = useState([]);
  const [filterPrintData, setFilterPrintData] = useState([]);
  const [searchParams, setSearchParams] = useState({ projectId: 0, branchId: 0, warehouseId: 0, includeStartDate: true, includeEndDate: true });
  const [projects, setProjects] = useState([]);
  const [allProjects, setAllProjects] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [warehousesData, setWarehousesData] = useState([]);
  const [isPositive, setIsPositive] = useState();
  const [branches, setBranches] = useState([]);
  const [accountingGroup, setAccountingGroup] = useState([]);
  const [showProgress, setShowProgress] = useState(false);
  const searchObj = { CompanyBranch: 0, PurchaseType: -1, StartDate: helper().formatDate(searchParams?.startDate, 'MM-dd-yyyy'), EndDate: helper().formatDate(searchParams?.endDate, 'MM-dd-yyyy') }
  const printRef = useRef();
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 15 }, (_, i) => {
    const year = currentYear - i;
    return { label: year, value: year };
  });
  const [selectedYear, setSelectedYear] = useState(currentYear);



  ///const [startDate, setStartDate] = useState(new Date());

  useEffect(() => {
    getDates(selectedYear);
    getBranches();
    getProjects();
    getWarehouses();
    getAccountingGroups();
    setIsPositive(false);

  }, [])


  useEffect(() => {
    if (isPositive === true) {
      setFilterPrintData(dataForPrint)
    } else {
      let filteredArray = dataForPrint.filter(obj => obj.listItem != true);
      setFilterPrintData(filteredArray);
    }

  }, [dataForPrint, isPositive])

  const exportToExcel = () => {
    // let table = document.getElementById('table-to-xls-1').innerHTML;
    let fileName = helper().translate("INCOME_STATEMENT");
    // return helper().exportToExcel(table, fileName)
    excelExportRef.current.exportToExcel(fileName)
    //"Conversion failed when converting date and/or time from character string."
  }

  const print = () => {
    printRef.current.printPreview()
  }

  const headers = [
    { key: 'name', columnName: helper().translate("NAME"), type: "text" },
    { key: 'month1', columnName: helper().translate("JANUARY"), type: "number" },
    { key: 'month2', columnName: helper().translate("FEBRUARY"), type: "number" },
    { key: 'month3', columnName: helper().translate("MARCH"), type: "number" },
    { key: 'month4', columnName: helper().translate("APRILL"), type: "number" },
    { key: 'month5', columnName: helper().translate("MAY"), type: "number" },
    { key: 'month6', columnName: helper().translate("JUNE"), type: "number" },
    { key: 'month7', columnName: helper().translate("JULY"), type: "number" },
    { key: 'month8', columnName: helper().translate("AUGUST"), type: "number" },
    { key: 'month9', columnName: helper().translate("SEPTEMBER"), type: "number" },
    { key: 'month10', columnName: helper().translate("OCTOBER"), type: "number" },
    { key: 'month11', columnName: helper().translate("NOVEMBER"), type: "number" },
    { key: 'month12', columnName: helper().translate("DECEMBER"), type: "number" }
  ];


  //   const data = (data) =>{
  //     const modifiedData = [];
  //     let mData = data.filter(f => f.currentValue != 0)

  // for (const item of mData) {
  //   modifiedData.push({
  //     name: item.name,
  //     calculateId: item.calculateId,
  //     currentValue: item.currentValue,
  //     mainItem: true
  //   });

  //   if (item.groupsInfo && item.groupsInfo.length > 0) {
  //     for (const groupInfo of item.groupsInfo) {
  //       modifiedData.push({
  //         name: groupInfo.name.trim(), 
  //         currentValue: groupInfo.grValue,
  //         listItem: true
  //       });
  //     }
  //   }
  // }
  //   setDataForPrint(modifiedData)
  //   }

  const getAccountingGroups = () => {
    let options;
    apiService()
      .query("getAccountingGroups")
      .then((response) => {
        if (response.success) {
          setAccountingGroup(response.data);
          // console.log(response.data)
        } else {
          alert("Error: getting PlaniKontabel" + response.errorMessage);
        }
      });
  };


  const calculatesameAccNumberTransactions = (transactions) => {
    const aggregatedTransactions = transactions.reduce((result, transaction) => {
      const { accountNumber, debits, credits } = transaction;
      if (!result[accountNumber]) {
        result[accountNumber] = { ...transaction };
      } else {
        result[accountNumber].debits += debits;
        result[accountNumber].credits += credits;
      }
      return result;
    }, {});

    return Object.values(aggregatedTransactions);
  }


  const formatData = function (response) {

    let formatedData = [];
    // Balance sheet main classes  =  1 ASSETS - Pasurit  2 LIABILITIES - detyrimet and 3 EQUITY - Ekuiteti
    let mainClasses = [
      { groups: [400, 460], name: "Të Hyrat", calculateId: 1, saldo: "credits", id: 1 },
      { groups: [500, 560], name: "Kostoja e shitjes", calculateId: 1, saldo: "credits", id: 2 },
      { name: "Fitimi / (humbja) bruto", bold: true, calculateTotalId: 1, calculateId: 2, id: 3 },
      { groups: [402], range: [459], name: "Të ardhurat tjera", calculateId: 2, saldo: "credits", id: 4 },
      { groups: [600], range: [649], name: "Shpenzimet e shpërndarjes", calculateId: 2, saldo: "credits", id: 5 },
      { groups: [650], range: [669], name: "Shpenzimet e administrative", calculateId: 2, saldo: "credits", id: 6 },
      { groups: [670], range: [699], name: "Shpenzimet e tjera", calculateId: 2, saldo: "credits", id: 7 },
      { name: "Fitimi / (humbja) operative", bold: true, calculateTotalId: 2, calculateId: 3, id: 8 },
      { groups: [800], range: [899], name: "Shpenzimet Financiare", calculateId: 3, saldo: "credits", id: 9 },
      { groups: [461], range: [499], name: "Të ardhurat Financiare", calculateId: 3, saldo: "credits", id: 10 },
      { name: "Fitimi / (humbja) para tatimit", bold: true, calculateTotalId: 3, calculateId: 4, id: 11 },
      { groups: [700], range: [799], name: "Shpenzimet e tatimit në fitim", calculateId: 4, saldo: "credits", id: 12 },
      { name: "Fitimi / (humbja) i/e vitit", bold: true, calculateTotalId: 4, calculateId: 5, id: 13 }
    ]

    let expandedClasses = [];

    mainClasses.forEach(entry => {
      if (entry.groups && entry.groups.length === 1 && entry.range) {
        let start = entry.groups[0];
        let end = entry.range[0];
        for (let i = start; i <= end; i++) {
          expandedClasses.push({
            groups: [i],
            name: '',
            calculateId: entry.calculateId,
            saldo: entry.saldo
          });
        }
      } else {
        expandedClasses.push(entry);
      }
    });


    expandedClasses.forEach((m) => {
      let mainClass = {}
      if (m?.groups?.length === 2) {
        mainClass.name = m.name;
        mainClass.calculateId = m.calculateId;
        let resultMultipleGroups = 0;
        // for(let g = 0; g < 2; g++){
        //   console.log(m.groups[g])
        // 
        var groupInfo = [];
        m.groups.forEach(g => {
          let gValue = 0;
          if (m.saldo === "credits") {
            gValue = response.filter(i => i.groupId === g).map(i => i.credits - i.debits).reduce((partialSum, a) => partialSum + a, 0);
            if (response.filter(i => i.groupId === g)[0]?.groupName) {

              let obj = { name: response.filter(i => i.groupId === g)[0]?.groupName, grValue: gValue, idForSelect: response.filter(i => i.groupId === g)[0]?.groupId }
              groupInfo.push(obj)
            }
            // let obj = {grName:response.filter(i => i.groupId === g).groupName, }
          } else {
            gValue = response.filter(i => i.groupId === g).map(i => i.debits - i.credits).reduce((partialSum, a) => partialSum + a, 0);
            if (response.filter(i => i.groupId === g)[0]?.groupName) {

              let obj = { name: response.filter(i => i.groupId === g)[0]?.groupName, grValue: gValue }
              groupInfo.push(obj)
            }
          }
          resultMultipleGroups = resultMultipleGroups + gValue;
          mainClass.currentValue = resultMultipleGroups;
          mainClass.groupsInfo = groupInfo;
        });
      } else if (m?.groups?.length === 1) {
        if (m.name != '') {
          mainClass.name = m.name
        } else {
          let nameForMain = response.find(f => f.groupId === m?.groups[0])?.groupName
          typeof (nameForMain) != 'undefined' ? mainClass.name = nameForMain : mainClass.name = ""
        }
        mainClass.calculateId = m.calculateId;
        var groupInfo = [];
        let gValue = 0;
        if (m.saldo === "credits") {


          let resAccObj;
          if (m.range) {
            gValue = response.filter(i => i.groupId >= m.groups[0] && i.groupId <= m.range[0]).map(i => i.credits - i.debits).reduce((partialSum, a) => partialSum + a, 0);
            resAccObj = response.filter(i => i.groupId >= m.groups[0] && i.groupId <= m.range[0])
          } else {
            gValue = response.filter(i => i.groupId === m.groups[0]).map(i => i.credits - i.debits).reduce((partialSum, a) => partialSum + a, 0);
            resAccObj = response.filter(i => i.groupId === m.groups[0]);
          }
          let aggregatedTransactions = calculatesameAccNumberTransactions(resAccObj);
          aggregatedTransactions.forEach(e => {
            let obj = { name: e?.accName, grValue: parseFloat(e.credits - e.debits) }
            groupInfo.push(obj)
          });
        } else {

          let resAccObj;
          // if(m.range){
          //   gValue = response.filter(i => i.groupId >= m.groups[0] && i.groupId <= m.range[0]).map(i => i.debits - i.credits).reduce((partialSum, a) => partialSum + a, 0);
          //   resAccObj= response.filter(i => i.groupId >= m.groups[0] && i.groupId <= m.range[0])
          // }else{
          gValue = response.filter(i => i.groupId === m.groups[0]).map(i => i.debits - i.credits).reduce((partialSum, a) => partialSum + a, 0);
          resAccObj = response.filter(i => i.groupId === m.groups[0]);
          // }
          let aggregatedTransactions = calculatesameAccNumberTransactions(resAccObj);
          aggregatedTransactions.forEach(e => {
            let obj = { name: e?.accName, grValue: parseFloat(e.debits - e.credits) }
            groupInfo.push(obj)
          });
        }
        mainClass.currentValue = gValue;
        mainClass.groupsInfo = groupInfo;
        // console.log(gValue)
        // mainClass.name = accountingGroup.find(f => f.groupId === gId)?.name;

      } else {
        mainClass.name = m.name;
        mainClass.calculateTotalId = m.calculateTotalId;
        mainClass.calculateId = m.calculateId;
        let totalCalculated = formatedData.filter(f => f.calculateId === m.calculateTotalId).reduce((sum, currentItem) => {
          return sum + currentItem.currentValue;
        }, 0);
        mainClass.currentValue = totalCalculated;
      }
      formatedData.push(mainClass);

      // console.log(mainClass);
    });

    return formatedData;
  }

  const getDates = (year) => {
    // let eDate = new Date();
    // let sDate = new Date(eDate.getFullYear(),0,1,1); 
    if (year) {
      setSearchParams({ ...searchParams, startDate: getMonthRange(parseInt(1), year).startDate, endDate: getMonthRange(parseInt(12), year).endDate });

      getGeneralBookWithDetails(getMonthRange(parseInt(1), year).startDate, getMonthRange(parseInt(12), year).endDate, 0, 0, year);
    } else {

      setSearchParams({ ...searchParams, startDate: getMonthRange(parseInt(1), year).startDate, endDate: getMonthRange(parseInt(12), year).endDate });

      getGeneralBookWithDetails(getMonthRange(parseInt(1), year).startDate, getMonthRange(parseInt(12), year).endDate, 0, 0, year);

    }

  };

  function getMonthRange(monthNumber, year) {
    // monthNumber is 1-based (1 = January, 12 = December)


    // Start of month
    let startDate = new Date(year, monthNumber - 1, 1, 0, 0, 1);

    // End of month (day 0 of next month = last day of given month)
    let endDate = new Date(year, monthNumber, 0, 23, 59, 59);

    return { startDate, endDate };
  }




  // const getGeneralBookWithDetails = (startDate, endDate, branchId, projectId) => {

  //   if (!projectId) {
  //     projectId = 0;
  //   }

  //   let strStartDate = helper().formatDate(startDate,'MM-dd-yyyy');
  //   let strEndDate = helper().formatDate(endDate,'MM-dd-yyyy') + " 23:59:59";

  //   setShowProgress(true);

  //   var params = `&startDate=${strStartDate}&endDate=${strEndDate}&branchId=${branchId}&projectId=${projectId}`;
  //   apiService().query('fnGeneralBookWithDetails', params).then((response) => {
  //     if (response.success) {
  //       let formatedData = formatData(response.data);

  //       let pStartDate = new Date(endDate.getFullYear() - 1, 0, 1);
  //       let month = endDate.getMonth();
  //       let day = endDate.getDate();
  //       let pEndDate = new Date(endDate.getFullYear() -1, month, day);

  //       setSearchParams({ ...searchParams, startDate: startDate, endDate: endDate, prevStartDate: pStartDate, prevEndDate: pEndDate});

  //       setMainData(formatedData);
  //       data(formatedData);
  //       setShowProgress(false);

  //     } else {
  //       console.log('Error:' + response.errorMessage);
  //     }
  //   });
  // };

  function formatFinancialData(allResults) {
    const months = Array.from({ length: 12 }, (_, i) => i + 1); // [1, 2, ..., 12]
    const nameMap = new Map(); // Track unique names and their monthly data

    // Process each month's data
    allResults.forEach(result => {
      result.data.forEach(item => {
        const { name, currentValue, groupsInfo } = item;

        // Handle main names
        if (name) {
          if (!nameMap.has(name)) {
            nameMap.set(name, {
              name,
              monthlyData: months.map(month => ({
                month,
                value: 0
              })),
              subItems: new Map() // Track sub-items (groupsInfo)
            });
          }
          const entry = nameMap.get(name);
          const monthData = entry.monthlyData.find(d => d.month === result.month);
          if (monthData) {
            monthData.value = currentValue || 0;
          }

          // Handle groupsInfo for this name
          if (groupsInfo && groupsInfo.length > 0) {
            groupsInfo.forEach(group => {
              const subKey = `${group.name}-${group.idForSelect}`;
              if (!entry.subItems.has(subKey)) {
                entry.subItems.set(subKey, {
                  name: group.name,
                  idForSelect: group.idForSelect,
                  monthlyData: months.map(month => ({
                    month,
                    value: 0
                  }))
                });
              }
              const subEntry = entry.subItems.get(subKey);
              const subMonthData = subEntry.monthlyData.find(d => d.month === result.month);
              if (subMonthData) {
                subMonthData.value = group.grValue || 0;
              }
            });
          }
        }
      });
    });

    // Convert to final array structure
    const formattedData = Array.from(nameMap.values()).map(entry => ({
      ...entry,
      subItems: Array.from(entry.subItems.values())
    }));

    return formattedData;
  }
  const getGeneralBookWithDetails = async (startDate, endDate, branchId, projectId, yearSelected) => {
    if (!projectId) {
      projectId = 0;
    }

    const parsedEndDate = endDate instanceof Date ? endDate : new Date(endDate);
    // Fall back to the currently selected year or a valid endDate year so the header row always shows the correct year
    const reportYear = yearSelected ?? selectedYear ?? (parsedEndDate instanceof Date && !Number.isNaN(parsedEndDate?.getTime()) ? parsedEndDate.getFullYear() : new Date().getFullYear());

    setShowProgress(true);

    try {
      // Create array of 12 months
      const monthPromises = Array.from({ length: 12 }, (_, i) => {
        // First day of month i
        const mStart = new Date(reportYear, i, 1);
        // Last day of month i
        const mEnd = new Date(reportYear, i + 1, 0, 23, 59, 59);

        const strStartDate = helper().formatDate(mStart, "MM-dd-yyyy");
        const strEndDate = helper().formatDate(mEnd, "MM-dd-yyyy") + " 23:59:59";
        const params = `&startDate=${strStartDate}&endDate=${strEndDate}&branchId=${branchId}&projectId=${projectId}`;

        return apiService().query("fnGeneralBookWithDetails", params);
      });

      // Run all 12 API calls in parallel
      const responses = await Promise.all(monthPromises);

      // Format results
      const allResults = responses.map((res, i) => {
        if (res.success) {
          return {
            month: i + 1,
            data: formatData(res.data)
          };
        } else {
          console.error(`Error in month ${i + 1}:`, res.errorMessage);
          return { month: i + 1, data: null };
        }
      });

      const newObject = {
        name: "Data",
        monthlyData: Array.from({ length: 12 }, (_, index) => ({
          month: index + 1,
          value: `${(index + 1).toString().padStart(2, '0')}.${reportYear}`
        })),
        subItems: []
      };


      // console.log(formatData(allResults[7].data))
      // console.log(allResults)
      // console.log("All 12 months data:", allResults);
      // Example: us

      const dataFr = formatFinancialData(allResults);
      dataFr.unshift(newObject);
      setMainData(reorderData(dataFr));
      let dataofobje = reorderData(dataFr)
      const transformed = transformArray(dataofobje);
      setDataForPrint(transformed)


    } catch (error) {
      console.error("Unexpected error:", error);
    } finally {
      setShowProgress(false);
    }
  };

  const reorderData = (data) => {
    const headOrder = [
      "Data",
      "Të Hyrat",
      "Kostoja e shitjes",
      "Fitimi / (humbja) bruto",
      "Të ardhurat tjera",
      "Shpenzimet e shpërndarjes"
    ];

    const tailOrder = [
      "Fitimi / (humbja) operative",
      "Fitimi / (humbja) para tatimit",
      "Fitimi / (humbja) i/e vitit"
    ];

    const head = headOrder
      .map(name => data.find(item => item.name === name))
      .filter(Boolean);

    const middle = data.filter(item => !headOrder.includes(item.name) && !tailOrder.includes(item.name));

    const tail = tailOrder
      .map(name => data.find(item => item.name === name))
      .filter(Boolean);

    return [...head, ...middle, ...tail];
  };




  function transformArray(dataArray) {
    // helper to convert monthlyData into flat object
    const convert = (item, bol) => {
      const flat = { name: item.name, mainItem: bol === true ? true : false };
      item.monthlyData.forEach(m => {
        flat[`month${m.month}`] = m.value;
      });
      return flat;
    };

    let result = [];

    dataArray.forEach(item => {
      // push main object
      result.push(convert(item, true));

      // push subItems if exist
      if (item.subItems && Array.isArray(item.subItems)) {
        item.subItems.forEach(sub => {
          result.push(convert(sub, false));
        });
      }
    });
    result = result.filter(obj => obj.name !== "Data");
    return result;
  }


  const getProjects = () => {

    apiService()
      .query("getProjects").then((response) => {
        if (response.success) {
          let data = response.data;
          setAllProjects(data);
          // Initialize options based on current branch filter
          filterProjectsByBranch(searchParams.branchId, data, warehousesData);

        } else {
          alert("Error: getting Projects" + response.errorMessage);
        }
      });
  };

  const getWarehouses = () => {
    apiService()
      .get("warehouses").then((response) => {
        if (response.success) {
          let data = response.data;
          let firstItem = { id: null, name: helper().translate("ALL_WAREHOUSES") };
          const dataWithAll = [firstItem, ...data];
          let options = dataWithAll.map((item, index) => ({
            value: item.id,
            label: item.name,
            branchId: item.branchId
          }));
          setWarehouses(options);
          setWarehousesData(data); // keep raw for branch mapping
          // Re-filter projects if they are already loaded
          if (allProjects && allProjects.length) {
            filterProjectsByBranch(searchParams.branchId, allProjects, data);
          }
        } else {
          alert("Error: getting warehouses" + response.errorMessage);
        }
      });
  };

  const filterProjectsByBranch = (branchId, projectsRaw = allProjects, warehousesRaw = warehousesData) => {
    // When no branch selected, show all projects
    if (!branchId) {
      const opts = [{ value: null, label: helper().translate("ALL_PROJECTS") },
      ...projectsRaw.map(p => ({ value: p.id, label: p.name }))];
      setProjects(opts);
      return;
    }
    const warehouseIds = new Set(
      (warehousesRaw || [])
        .filter(w => w.branchId === branchId)
        .map(w => w.id)
    );
    const filtered = (projectsRaw || []).filter(p => warehouseIds.has(p.WarehouseId || p.warehouseId));
    const opts = [{ value: null, label: helper().translate("ALL_PROJECTS") },
    ...filtered.map(p => ({ value: p.id, label: p.name }))];
    setProjects(opts);
  };

  const getBranches = () => {

    apiService()
      .get("Branches").then((response) => {
        if (response.success) {

          let data = response.data;

          let firstItem = { id: null, name: helper().translate("ALL_BRANCHES") };
          data.unshift(firstItem);

          let options = data.map((item, index) => ({
            value: item.id,
            label: item.name
          }));

          setBranches(options);

        } else {
          alert("Error: getting branches" + response.errorMessage);
        }
      });
  };

  const selectChange = (e, obj) => {
    if (obj.name === 'branches') {
      // Reset project selection when branch changes
      const next = { ...searchParams, branchId: e.value, projectId: null };
      setSearchParams(next);
      // filter project options by selected branch and clear selection
      filterProjectsByBranch(e.value);
      // auto refresh
      let { startDate, endDate, includeStartDate, includeEndDate, projectId } = next;
      if (includeStartDate === false) {
        const year = new Date(endDate).getFullYear();
        startDate = `${year}-01-01 00:00:00`;
      } else if (includeEndDate === false) {
        endDate = "2222-01-01";
      }
      const branch = next.branchId === null ? 0 : next.branchId;
      getGeneralBookWithDetails(startDate, endDate, branch, projectId, selectedYear);
    }
    else if (obj.name === 'projects') {
      const next = { ...searchParams, projectId: e.value };
      setSearchParams(next);
      // auto refresh
      let { startDate, endDate, includeStartDate, includeEndDate, branchId } = next;
      if (includeStartDate === false) {
        const year = new Date(endDate).getFullYear();
        startDate = `${year}-01-01 00:00:00`;
      } else if (includeEndDate === false) {
        endDate = "2222-01-01";
      }
      const branch = branchId === null ? 0 : branchId;
      getGeneralBookWithDetails(startDate, endDate, branch, next.projectId, selectedYear);
    }
  }

  const onSearchClick = () => {

    let startDate = searchParams.startDate;
    let endDate = searchParams.endDate;

    if (searchParams.includeStartDate === false) {
      let year = new Date(endDate).getFullYear();
      startDate = `${year}-01-01 00:00:00`;
    } else if (searchParams.includeEndDate === false) {
      endDate = "2222-01-01";
    }

    if (searchParams.branchId === null) {
      searchParams.branchId = 0;
    }

    getGeneralBookWithDetails(startDate, endDate, searchParams.branchId, searchParams.projectId, selectedYear)
  }

  const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      borderColor: "#9e9e9e",
      minHeight: "28.59px",
      height: "28.59px",
      boxShadow: state.isFocused ? null : null,
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      height: "28.59px",
      padding: "0 6px",
    }),

    input: (provided, state) => ({
      ...provided,
      margin: "0px",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "28.59px",
    }),
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.value);
    getDates(parseInt(e.value))
  }

  return (
    <div className="container-fluid px-2 mt-3 pt-1">
      <Search back="#/reports" printClick={print} excel={() => exportToExcel()} />
      <ExcelExport data={dataForPrint.length ? dataForPrint : []} headers={headers} type={'other'} ref={excelExportRef} hideContent={true} />
      <Print data={dataForPrint.length ? dataForPrint : []} headers={headers.filter(header => header !== false)} ref={printRef} query={searchObj} reportName={helper().translate("MONTH_REPORT_OF_INCOME_AND_EXPENSES")} />
      <div className="card shadow mt-1">
        <div className="card-header border-left-primary py-2"><h6 className="m-0 font-weight-bold text-primary text-center">{helper().translate("MONTH_REPORT_OF_INCOME_AND_EXPENSES")}</h6>
          <div style={{ paddingTop: "2px" }} className=" mb-3 mb-md-0">
            <div className="row g-2 justify-content-center">
              <div className="col-12 col-md-4">
                <Select
                  name="year"
                  placeholder={helper().translate("YEAR")}
                  styles={selectStyles}
                  id="year"
                  onChange={(e, obj) => handleYearChange(e, obj)}
                  options={years}
                  value={years?.find(p => p.value === selectedYear)}
                />
              </div>
              <div className="col-12 col-md-4">
                <Select
                  name="branches"
                  placeholder={helper().translate("BRANCH")}
                  styles={selectStyles}
                  options={branches}
                  onChange={(e, obj) => selectChange(e, obj)}
                  value={branches?.find(b => b.value === searchParams.branchId)}
                />
              </div>
              <div className="col-12 col-md-4">
                <Select
                  name="projects"
                  placeholder={helper().translate("PROJECT")}
                  styles={selectStyles}
                  options={projects}
                  onChange={(e, obj) => selectChange(e, obj)}
                  value={projects?.find(p => p.value === searchParams.projectId)}
                />
              </div>
            </div>
          </div>
        
        </div>

        {showProgress &&
          <div style={{ position: 'absolute', top: '10px', right: '40px', zIndex: 1000, color: '#4E73DF', fontSize: 18 }}>{helper().translate('LOADING')} ...</div>
        }
      </div>
      <MonthlyRptFormat data={mainData} />
    </div>

  )
}

export default AccMonthlyReport;
